import React from 'react'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'

export const IosAppInstall = () => {
  return (
    <>        
        <a href="https://itunes.apple.com/us/app/stringssg/id1347513244" target="_blank" rel="noreferrer" className='fixed bg-gray-200 w-full flex justify-center'>
            <Image className='bg-white rounded-lg' 
            height={40} 
            width={140}
            style={{width: "130px", height: "42px"}}
            priority={false}
            src={s3Static + "apple-store-badge.png"} alt="StringsSG apple store"/>
        </a>
    </>
  )
}
